<div class="form-wrapper">
    <p class="urgent">For urgent or after-hours requests, please call 1-800-328-7287. Normal business hours are 8am-5pm CST, Monday-Friday.</p>
    <mat-vertical-stepper #stepper>
        <mat-step [stepControl]="part_information">
            <form [formGroup]="part_information">
                <ng-template matStepLabel>Part Information</ng-template>
                <div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayout.xs="column">
                    <mat-form-field fxFlex="30" fxFlex.sm="45" appearance="fill">
                        <mat-label>Part OEM</mat-label>
                        <input maxlength="100" type="text" matInput formControlName="oem" required />
                    </mat-form-field>                    
                    <mat-form-field fxFlex="30" fxFlex.sm="45" appearance="fill">
                        <mat-label>OEM Part Number</mat-label>
                        <input maxlength="100" type="text" matInput formControlName="partno" required />
                    </mat-form-field>
                    <mat-form-field fxFlex="30" fxFlex.sm="45" appearance="fill">
                        <mat-label>Customer Part Number</mat-label>
                        <input type="text" matInput formControlName="customerpartno" />
                    </mat-form-field>                    
                    <mat-form-field fxFlex="30" fxFlex.sm="45" appearance="fill">
                        <mat-label>Machine OEM</mat-label>
                        <input type="text" matInput formControlName="machineoem"/>
                    </mat-form-field>
                    <mat-form-field fxFlex="65" fxFlex.sm="100" appearance="fill">
                        <mat-label>Function/Description</mat-label>
                        <textarea maxlength="500" rows="3" matInput formControlName="function" required></textarea>
                    </mat-form-field>
                </div>
                <div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayout.xs="column">
                    <mat-form-field fxFlex="10" fxFlex.sm="45" appearance="fill">
                        <mat-label>Quantity</mat-label>
                        <input type="number" matInput formControlName="quantity" required />
                        <mat-error *ngIf="part_information.get('quantity')?.dirty && part_information.get('quantity')?.invalid">Value must be greater than 0 and less than 999999999.</mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="20" fxFlex.sm="45" appearance="fill">
                        <mat-label>MDS Part ID</mat-label>
                        <input type="number" placeholder="Existing FMS parts only" matInput formControlName="mdspartno" />
                        <mat-error *ngIf="part_information.get('mdspartno')?.dirty && part_information.get('mdspartno')?.invalid">Value must be less than 18 digits.</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill" fxFlex="30" fxFlex.sm="45">
                        <mat-label>Product Option</mat-label>
                        <mat-select formControlName="productoptions" multiple required>
                          <mat-option *ngFor="let option of productOptions" [value]="option">{{option}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="part_information.get('productoptions')?.dirty && part_information.get('productoptions')?.invalid">At least one product option must be selected.</mat-error>
                    </mat-form-field>
                    <div class="w-100" fxFlexAlign="center" fxFlexAlign.xs="start" fxFlex="30" fxFlex.sm="60">
                        <input (change)="validateAttachments(getAttachments())" hidden="true" #attachmentElementRef type="file" multiple="true" [accept]="allowedFileExts.join(',')" />
                        <div class="attachment-overlay">
                            <div fxLayout="row">
                                <div fxFlex="80">Attachments</div>
                                <div (click)="attachmentElementRef.click()" class="att-add" fxFlexAlign="end" fxFlex="20">+</div>   
                            </div>
                            <div class="att-container">
                                <div *ngFor="let att of getAttachments()">
                                    {{att.name}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-20" fxLayout="row">
                    <button [disabled]="!part_information.valid" mat-raised-button color="primary" matStepperNext>Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step *ngIf="part_information.get('productoptions')?.value && this.part_information.get('productoptions')?.value.indexOf('Repair') >= 0" [stepControl]="repair_information">
            <form [formGroup]="repair_information">
                <ng-template matStepLabel>Repair Information (If Applicable)</ng-template>
                <div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayout.xs="column">
                    <mat-form-field fxFlex="30" fxFlex.sm="60" appearance="fill">
                        <mat-label>Type of Repair</mat-label>
                        <mat-select formControlName="type">
                          <mat-option *ngFor="let type of repair_types" [value]="type">{{type}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between" fxLayout.xs="column">
                    <mat-form-field fxFlex="100" appearance="fill">
                        <mat-label>Description of Problem</mat-label>
                        <textarea maxlength="500" rows="5" matInput formControlName="description"></textarea>
                    </mat-form-field>
                </div>
                <div class="mt-20" fxLayout="row">
                    <button mat-raised-button matStepperPrevious>Back</button>
                    <button class="ml-25" [disabled]="!repair_information.valid" mat-raised-button color="primary" matStepperNext>Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="requestor_information">
            <form [formGroup]="requestor_information">
                <ng-template matStepLabel>Requestor Information</ng-template>
                <div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayout.xs="column">
                    <mat-form-field fxFlex="30" fxFlex.sm="100" appearance="fill">
                        <mat-label>Company Name</mat-label>
                        <input maxlength="100" type="text" matInput formControlName="company" />
                    </mat-form-field>                    
                    <mat-form-field fxFlex="30" fxFlex.sm="45" appearance="fill">
                        <mat-label>First Name</mat-label>
                        <input maxlength="100" type="text" matInput formControlName="firstname" required />
                    </mat-form-field>
                    <mat-form-field fxFlex="30" fxFlex.sm="45" appearance="fill">
                        <mat-label>Last Name</mat-label>
                        <input maxlength="100" type="text" matInput formControlName="lastname" required />
                    </mat-form-field>
                </div>
                <div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayout.xs="column">
                    <mat-form-field fxFlex="30" fxFlex.sm="45" appearance="fill">
                        <mat-label>Address</mat-label>
                        <input maxlength="100" type="text" matInput formControlName="line1" required />
                    </mat-form-field>                    
                    <mat-form-field fxFlex="30" fxFlex.sm="45" appearance="fill">
                        <mat-label>City</mat-label>
                        <input maxlength="100" type="text" matInput formControlName="city" required />
                    </mat-form-field>
                    <mat-form-field fxFlex="15" fxFlex.sm="45" appearance="fill">
                        <mat-label>State</mat-label>
                        <mat-select formControlName="state" required>
                          <mat-option *ngFor="let s of states" [value]="s">{{s}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="15" fxFlex.sm="45" appearance="fill">
                        <mat-label>ZIP/Postal Code</mat-label>
                        <input minlength="5" maxlength="5" type="text" matInput formControlName="zip" pattern="^[0-9]*$" required />
                        <mat-error *ngIf="this.requestor_information.get('zip')?.dirty && this.requestor_information.get('zip')?.invalid">Must be a 5 digit numeric Zip/Postal Code.</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayout.xs="column">
                    <mat-form-field fxFlex="30" fxFlex.sm="100" appearance="fill">
                        <mat-label>Email Address</mat-label>
                        <input maxlength="100" type="email" matInput formControlName="email" required pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$" />
                        <mat-error *ngIf="this.requestor_information.get('email')?.dirty && this.requestor_information.get('email')?.invalid">Must be a valid email format.</mat-error>
                    </mat-form-field>                    
                    <mat-form-field fxFlex="15" fxFlex.sm="45" appearance="fill">
                        <mat-label>Phone Number</mat-label>
                        <input maxlength="50" type="text" matInput formControlName="phone" />
                    </mat-form-field>
                    <mat-form-field fxFlex="15" fxFlex.sm="45" appearance="fill">
                        <mat-label>Fax Number</mat-label>
                        <input maxlength="50" type="text" matInput formControlName="fax" />
                    </mat-form-field>
                    <div fxFlex="20" fxFlex.sm="100">
                        <label for="preferred_contact_method">Preferred Method of Contact</label>
                        <mat-radio-group name="preferred_contact_method" formControlName="preference" required>
                            <mat-radio-button value="email">Email</mat-radio-button>
                            <mat-radio-button [disabled]="this.requestor_information.get('phone')?.value == null || this.requestor_information.get('phone')?.value === ''" value="phone">Phone</mat-radio-button>
                            <mat-radio-button [disabled]="this.requestor_information.get('fax')?.value == null || this.requestor_information.get('fax')?.value === ''" value="fax">Fax</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="mt-20" fxLayout="row">
                    <button mat-raised-button matStepperPrevious>Back</button>
                    <button class="ml-25" [disabled]="!requestor_information.valid" mat-raised-button color="primary" matStepperNext>Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="additional_information">
            <form [formGroup]="additional_information">
                <ng-template matStepLabel>Additional Information</ng-template>
                <div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayout.xs="column">
                    <mat-form-field fxFlex="30" fxFlex.sm="45" appearance="fill">
                        <mat-label>Quote Needed By</mat-label>
                        <input type="date" matInput formControlName="quoteneededby" />
                    </mat-form-field>
                    <mat-form-field fxFlex="30" fxFlex.sm="45" appearance="fill">
                        <mat-label>Required Delivery to Site</mat-label>
                        <input type="date" matInput formControlName="requireddeldate" />
                    </mat-form-field>
                    <div fxAlign.sm="center" ngClass.lt-md="mt-20 mb-20" ngClass.gt-sm="text-center" fxFlex="20" fxFlex.sm="45">
                        <mat-checkbox formControlName="hotorder">Hot Order</mat-checkbox>
                    </div>                    
                    <mat-form-field fxFlex="50" fxFlex.sm="100" appearance="fill">
                        <mat-label>Comments</mat-label>
                        <textarea maxlength="500" rows="5" matInput formControlName="comments"></textarea>
                    </mat-form-field>
                </div>
                <div class="mt-20" fxLayout="row">
                    <button mat-button matStepperPrevious>Back</button>
                    <button type="submit" class="ml-25" [disabled]="!part_information.valid || !repair_information.valid || !requestor_information.valid || !additional_information.valid" (click)="formSubmit()" color="primary" mat-raised-button>Submit</button>
                </div>
            </form>
        </mat-step>
    </mat-vertical-stepper>
</div>